import _ from 'lodash'
import { UPDATE_LISTING_FORM_KEY } from '../../../constants/proposalTypes'
import {
  loadLocal,
  saveIntoLocal,
  removeLocal
} from '../../../lib/localStorageHelper'

const COMPONENT_STATE_KEY = 'COMPONENT_STATE_KEY'

export const saveCompStateToStorage = (state) => {
  // reserviceError 遇到 error code 40100003 判斷為 okta 過期
  // 在 user 同意 "更新驗證資料" 後馬上把 redux form 存到 local storage
  // 所以在離開頁面前如果 storage 有資料代表即將要 okta redirect
  const isRefreshOkta = !_.isEmpty(loadLocal(UPDATE_LISTING_FORM_KEY))
  if (isRefreshOkta) {
    saveIntoLocal(COMPONENT_STATE_KEY, state)
  }
}

export const getFormStateFromStorage = () => {
  const formState = loadLocal(UPDATE_LISTING_FORM_KEY)
  return _.isEmpty(formState) ? {} : formState
}

export const getCompStateFromStorage = () => {
  const compState = loadLocal(COMPONENT_STATE_KEY)
  return _.isEmpty(compState) ? {} : compState
}

export const clearStateFromStorage = () => {
  const stateKeys = [UPDATE_LISTING_FORM_KEY, COMPONENT_STATE_KEY]
  stateKeys.map(removeLocal)
}
